module.exports = __webpack_public_path__ + "img/birthday-2014.4545bc23.jpg";